import { Box, Typography } from '@mui/material'
import FormModalContainer from '../Modals/FormModalContainer'
import OfoqThemeBtn from '../Buttons/OfoqThemeBtn'

// Whole sentences per biometry type rather than a label interpolated into a
// shared sentence: Arabic does not keep the English word order, so a split
// string leaves the label stranded in the middle of a translated phrase.
const COPY = {
  face: {
    title: 'Enable Face ID login?',
    body: 'Use your Face ID to log in faster next time.',
  },
  fingerprint: {
    title: 'Enable fingerprint login?',
    body: 'Use your fingerprint to log in faster next time.',
  },
}

const EnableBiometricPrompt = ({ open, type, loading, onAccept, onDecline, t }) => {
  const copy = COPY[type]

  // Only Face ID and fingerprint have copy the user would recognise, so any
  // other biometry the device reports is simply not offered.
  if (!copy) return null

  return (
    <FormModalContainer
      modalState={open}
      handleClose={onDecline}
      modalTitle={t?.[copy.title] || copy.title}
      cancelText={t?.['Not now'] || 'Not now'}
      mediumSize
    >
      <Box sx={styles.textContainer}>
        <Typography variant="heading4" sx={styles.messageText}>
          {t?.[copy.body] || copy.body}
        </Typography>
      </Box>

      <Box sx={styles.buttonsContainer}>
        <OfoqThemeBtn
          cancelStyle
          disabled={loading}
          onClick={onDecline}
          name={t?.['Not now'] || 'Not now'}
          customStyle={styles.cancelBtn}
        />
        <OfoqThemeBtn
          disabled={loading}
          onClick={onAccept}
          name={t?.Enable || 'Enable'}
          customStyle={styles.confirmBtn}
        />
      </Box>
    </FormModalContainer>
  )
}

const styles = {
  textContainer: {
    padding: '10px',
    textAlign: 'start',
    margin: '10px 0',
  },
  messageText: {
    marginBottom: '26px',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: 'grey.200',
    padding: '20px 10px',
    margin: '-16px',
    marginTop: 0,
    gap: '10px',
  },
  // Hidden on mobile, where the sheet's own header carries the cancel action.
  cancelBtn: { display: { xs: 'none', sm: 'initial' }, textAlign: 'center', width: '96px' },
  confirmBtn: { minWidth: '110px', maxWidth: 'fit-content', padding: '0 15px' },
}

export default EnableBiometricPrompt
